import { useMemo } from 'react'

import styled, { css } from 'styled-components'

import {
  getFallbackCardDisplay,
  ticketCardDisplay,
  CardDisplay,
  ticketNameToKey,
  TicketCardRenderer,
  CardTicket,
} from './TicketCardRenderer'

import { Popover } from '@/components/shared-components/BUI/Popover'

const BabyCard = styled.div`
  position: relative;
  width: 35px;
  height: 20px;
  border-radius: 3px;
  overflow: hidden;
`

const Line = styled.div`
  position: absolute;
  top: 4px;
  left: 0.25rem;
  width: 5px;
  height: 1px;
  opacity: 0.5;
`

type StripeProps = {
  position: CardDisplay['stripe']['position']
}

const Stripe = styled.div<StripeProps>`
  position: absolute;

  ${({ position }) =>
    position === 'top' &&
    css`
      top: 0;
      left: 0;
      width: 100%;
      height: 5px;
    `}

  ${({ position }) =>
    position === 'right' &&
    css`
      top: 0;
      right: 0;
      width: 5px;
      height: 100%;
    `}
`

type Props = {
  ticket: CardTicket
}

export const BabyTicket: React.FC<Props> = ({ ticket }) => {
  const display = useMemo(
    () => ticketCardDisplay[ticketNameToKey[ticket.ticketTemplate?.shortName]],
    [ticket.ticketTemplate?.shortName]
  )

  const stateDisplay = useMemo(() => {
    if (!display) return getFallbackCardDisplay(ticket.stateIssued)

    return display[ticket.stateIssued] ?? display.default
  }, [display, ticket.stateIssued])

  return (
    <Popover
      trigger={['hover']}
      showArrow={false}
      overlayStyle={{ minWidth: '360px' }}
      overlayInnerStyle={{ borderRadius: '1rem' }}
      content={
        <TicketCardRenderer
          ticket={ticket}
          showTicketInfo={false}
          ticketInfoOffset="0rem"
          ticketInfoBackground={false}
        />
      }
    >
      <BabyCard style={{ backgroundColor: stateDisplay.color }}>
        <Line style={{ backgroundColor: stateDisplay.textColor ?? 'white' }} />
        {stateDisplay.stripe && (
          <Stripe
            position={stateDisplay.stripe.position}
            style={{ backgroundColor: stateDisplay.stripe.color }}
          />
        )}
      </BabyCard>
    </Popover>
  )
}
